import { Wizard } from '../../../core/wizard/wizard';
import { CaptureDescriptionPageComponent } from './capture-description-page/capture-description-page.component';

export class CaptureDescriptionWizard extends Wizard<any> {
  key = 'capture-description';
  pageTypeMap = {
    'capture-description': CaptureDescriptionPageComponent
  };
  startingPageKey = 'capture-description';
}

export interface CaptureDescriptionWizardModel {
  description?: string;
  result?: string;
}